// import { disabledFriday } from '@/configs/general.configs';
import moment from 'moment';
// import store from '../store';
import { entityType } from './enums';

export function getEntityNameByType (type) {
	switch (type) {
	case entityType.doctor: return 'doctor';
	case entityType.center: return 'center';
	case entityType.pharmacy: return 'pharmacy';
	default: return null;
	}	
}

export function isTouchDevice() {
	return (
		window.matchMedia('(pointer: coarse)').matches ||
		('ontouchstart' in window) ||
		(navigator.maxTouchPoints > 0) ||
		(navigator.msMaxTouchPoints > 0)
	);
}

export function getWeekRange(date) {
	const m = moment(date)

	const start = m.clone().isoWeekday(6) // Saturday
	if (m.isoWeekday() < 6) {
		start.subtract(7, 'days')
	}

	const end = start.clone().add(5, 'days') // Thursday

	return {
		start: start.format('YYYY-MM-DD'),
		end: end.format('YYYY-MM-DD')
	}
}

// export function disableDates(date) {
// 	const d = moment(date).startOf('day');
// 	if (d.day() !== 5 && disabledFriday) return true;
// 	return store.state.vacations.some(v => d.isBetween(moment(v.fromDate).startOf('day'), moment(v.toDate).startOf('day'), 'day', '[]'));
// };

export const getDateColor = (date, vacations, options = {}) => {
	const { isDisabledFriday: disableFri = false, enableVacations: enableVac = true, vacationDayDetails = [] } = options;
    
	const target = moment(date);
	const dayOfWeek = target.day();
	const dayOfMonth = moment(target).format('YYYY-MM-DD');
	// const month = target.month();
	const formattedDate = target.format('YYYY-MM-DD');

	// تحقق من الجمعة المعطلة
	if (disableFri && dayOfWeek === 5) {
		return 'error'; // لون أحمر للعطل
	}

	// تحقق من العطل والإجازات
	if (enableVac && Array.isArray(vacations) && vacations.length > 0) {
		const isVacation = vacations.some(vacation => {
			if (!vacation) {
				return false;
			}
            
			// عطلة محددة (بدون تكرار)
			if (vacation.repeatType === null) {
				console.log('nulllll')
				console.log('formattedDate', formattedDate)
				console.log('vacationDayDetails', vacationDayDetails)
				console.log(vacationDayDetails.includes(formattedDate))
				return vacationDayDetails.includes(formattedDate);
			}

			// عطلة أسبوعية
			if (vacation.repeatType === 0) {
				const fromDay = moment(vacation.fromDate).day();
				const toDay = moment(vacation.toDate).day();

				const startRepeatDay = moment(vacation.startDate).day();
				const endRepeatDay = moment(vacation.endDate).day();

				if (fromDay > toDay) {
					return startRepeatDay === '0001-01-01T00:00:00' ? (dayOfWeek >= fromDay || dayOfWeek <= toDay) : (moment(moment(target).format('YYYY-MM-DD')).isBetween(vacation.startDate, vacation.endDate) || moment(target).isSame(vacation.startDate) || moment(target).isSame(vacation.endDate)) ? (dayOfWeek >= fromDay || dayOfWeek <= toDay) && (dayOfWeek >= startRepeatDay || dayOfWeek <= endRepeatDay) : false;
				}
				return startRepeatDay === '0001-01-01T00:00:00' ? (dayOfWeek >= fromDay && dayOfWeek <= toDay) : (moment(moment(target).format('YYYY-MM-DD')).isBetween(vacation.startDate, vacation.endDate) || moment(target).isSame(vacation.startDate) || moment(target).isSame(vacation.endDate)) ? (dayOfWeek >= fromDay && dayOfWeek <= toDay) : false;
			}

			// عطلة شهرية
			if (vacation.repeatType === 1) {
				const startRepeat = moment(vacation.startDate).format('YYYY-MM-DD');
				const endRepeat = moment(vacation.endDate).format('YYYY-MM-DD');
				
				if (vacation.toDate) {
					return startRepeat && endRepeat && moment(moment(target).format('YYYY-MM-DD')).isBetween(startRepeat, endRepeat) 
						? moment(dayOfMonth).format('D') >= moment(vacation.fromDate).format('D') && moment(dayOfMonth).format('D') <= moment(vacation.toDate).format('D') 
						: moment(dayOfMonth).format('D') >= moment(vacation.fromDate).format('D') && moment(dayOfMonth).format('D') <= moment(vacation.toDate).format('D') 
				}
				return dayOfMonth === vacation.fromDate;
			}

			// عطلة سنوية
			if (vacation.repeatType === 2) {
				// const vacationDate = moment(vacation.fromDate);

				const startRepeat = moment(vacation.startDate).format('YYYY-MM-DD');
				const endRepeat = moment(vacation.endDate).format('YYYY-MM-DD');

				return moment(moment(target).format('YYYY-MM-DD')).isBetween(startRepeat, endRepeat) ? moment(dayOfMonth).format('MM-DD') >= moment(vacation.fromDate).format('MM-DD') && moment(dayOfMonth).format('MM-DD') <= moment(vacation.toDate).format('MM-DD') : moment(dayOfMonth).format('MM-DD') >= moment(vacation.fromDate).format('MM-DD') && moment(dayOfMonth).format('MM-DD') <= moment(vacation.toDate).format('MM-DD');
			}

			return false;
		});

		if (isVacation) {
			return 'error'; // لون أحمر للعطل
		}
	}

	return 'success'; // لون أخضر لليوم العادي
};

// export const disableDates = (date) => {
// 	const currentDate = new Date(date);
// 	currentDate.setHours(0, 0, 0, 0);

// 	// أولاً: تحقق مما إذا كان اليوم هو الجمعة (إذا كان خيار تعطيل الجمعة مفعّلاً)
// 	const isFriday = disabledFriday && currentDate.getDay() === 5;

// 	// ثانياً: تحقق مما إذا كان اليوم يقع ضمن فترة عطلة
// 	let isVacation = false;
// 	if (enableVacations) {
// 		const vacations = store.state.vacations || [];
// 		for (const vacation of vacations) {
// 			if (!vacation.fromDate || !vacation.toDate) {
// 				continue;
// 			}

// 			const from = new Date(vacation.fromDate);
// 			from.setHours(0, 0, 0, 0);
// 			const to = new Date(vacation.toDate);
// 			to.setHours(0, 0, 0, 0);

// 			// التعامل مع `repeatType` الذي قد يكون غير معرّف
// 			const repeatType = vacation.repeatType === null || vacation.repeatType === undefined ? -1 : parseInt(vacation.repeatType, 10);

// 			let isMatch = false;
// 			// لا تقم بتطبيق قواعد التكرار على التواريخ التي تسبق بداية العطلة
// 			if (repeatType !== -1 && currentDate < from) {
// 				continue;
// 			}

// 			switch (repeatType) {
// 			case 0: // تكرار أسبوعي
// 			{
// 				const currentDay = currentDate.getDay();
// 				const fromDay = from.getDay();
// 				const toDay = to.getDay();
// 				if (fromDay <= toDay) {
// 					isMatch = currentDay >= fromDay && currentDay <= toDay;
// 				} else { // في حال كانت الفترة تتجاوز نهاية الأسبوع (مثل: الجمعة إلى الإثنين)
// 					isMatch = currentDay >= fromDay || currentDay <= toDay;
// 				}
// 				break;
// 			}
// 			case 1: // تكرار شهري
// 			{
// 				const currentDay = currentDate.getDate();
// 				const fromDay = from.getDate();
// 				const toDay = to.getDate();
// 				if (fromDay <= toDay) {
// 					isMatch = currentDay >= fromDay && currentDay <= toDay;
// 				} else { // في حال كانت الفترة تتجاوز نهاية الشهر (مثل: من يوم 25 إلى يوم 5)
// 					isMatch = currentDay >= fromDay || currentDay <= toDay;
// 				}
// 				break;
// 			}
// 			case 2: // تكرار سنوي
// 			{
// 				const currentMonth = currentDate.getMonth();
// 				const currentDay = currentDate.getDate();
// 				const fromMonth = from.getMonth();
// 				const fromDay = from.getDate();
// 				const toMonth = to.getMonth();
// 				const toDay = to.getDate();

// 				// تحويل التواريخ إلى أرقام للمقارنة (الشهر * 100 + اليوم)
// 				const currentOrdinal = currentMonth * 100 + currentDay;
// 				const fromOrdinal = fromMonth * 100 + fromDay;
// 				const toOrdinal = toMonth * 100 + toDay;

// 				if (fromOrdinal <= toOrdinal) { // الفترة لا تتجاوز نهاية العام
// 					isMatch = currentOrdinal >= fromOrdinal && currentOrdinal <= toOrdinal;
// 				} else { // الفترة تتجاوز نهاية العام (مثل: من ديسمبر إلى يناير)
// 					isMatch = currentOrdinal >= fromOrdinal || currentOrdinal <= toOrdinal;
// 				}
// 				break;
// 			}
// 			default: // عطلة غير متكررة
// 				isMatch = currentDate >= from && currentDate <= to;
// 				break;
// 			}

// 			if (isMatch) {
// 				isVacation = true;
// 				break; // تم العثور على تطابق، لا داعي لمواصلة البحث
// 			}
// 		}
// 	}

// 	// يتم تعطيل التاريخ إذا كان يوم جمعة أو يقع ضمن عطلة
// 	return isFriday || isVacation;
// };